module.exports = __webpack_public_path__ + "img/Cocos Island.c13f3d31.svg";